import { combineReducers } from "@reduxjs/toolkit";
import userinfoReducer from "./features/userinfo/userinfoSlice";
import plaidReducer from "./features/plaid/plaidSlice";
import apexReducer from "./features/apex/apexSlice";
import identityReducer from "./features/plaid/identitySlice";

export const RESET_ALL_USER_DATA = "RESET_ALL_USER_DATA";
export const resetAllUserData = () => ({ type: RESET_ALL_USER_DATA });

const appReducer = combineReducers({
  userinfo: userinfoReducer,
  plaid: plaidReducer,
  apex: apexReducer,
  identity: identityReducer,
});

const rootReducer: typeof appReducer = (state, action) => {
  if (action.type === RESET_ALL_USER_DATA) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
